<template>
  <v-container
    class="pa-0"
    style="max-width:100%;background-color: var(--v-personBg-base);"
  >
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
    <swipe />
    <!--<v-dialog v-model="component_show">
      <v-card class="top_title"> &nbsp; 공지사항</v-card>
      <v-card>
      <span>
        &nbsp; <input type="checkbox" :id="'chkToday'"> &nbsp;5일동안 열지 않음 &nbsp;
        <v-btn varient="plain" size="small" @click="closeLayer"> 닫기</v-btn>
      </span>
      </v-card>
      <div class="main_content">
        <img src="@/assets/image/popup.jpg" width="100%">
      </div>
    </v-dialog>-->
    <v-card
      v-show="show"
      v-if="!isMobilePc"
      class="card--group overflow-y-auto pa-2"
      height="800px"
      width="340px"
      style="position:absolute;top:5%;right:10px;"
    >
      <div v-for="item in siteList" v-bind:key="item.SITE_ID">
        <site-card
          :refresh="refreshFlag"
          :site="item"
          @clickTitle="findMarker"
        ></site-card>
      </div>
    </v-card>
    <v-card class="mr-2 ml-2 ma-0 pa-2" style="background-color: #536592;">
      <private-plant></private-plant>
    </v-card>
  </v-container>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import {
  getMonitoringPersonal,
  getMonitoringTotal
} from '@/api/monitoring/monitoring'
import { dateRenew } from '@/api/common/login'

import day from 'dayjs'
import SiteCard from '@/components/monitoring/SiteCard'
import { isTablet } from '@/utils/check'
import store from '@/store'
import localStore from '@/utils/localStore'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import { isMobile } from '@/utils/check.js'
import PrivatePlant from '@/components/mobile/mPrivatePlant.vue'
import Swipe from '@/components/mobile/Swipe.vue'
import { confirmIfExit } from '@/api/greenCommon/confirmIfExit'

// [ECMA6] export default 된 부분이 외부에서 import로 사용할 수 있게 된다.
let infoWindow = {}
export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'PersonalMonitoring',
  components: {
    SiteCard,
    PrivatePlant,
    Swipe,
    GeneralDialog
  },
  data() {
    return {
      row_num: 0,
      component_key: 1,
      layer_type: 'SummaryPopup',
      component_show: false,
      refreshFlag: true,
      from: false,
      map: null,
      userId: '',
      sidoCode: '',
      siguCode: '',
      modal: false,
      popupTitle: '비밀번호 변경',
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      show: false,
      markerList: [],
      siteList: [],
      interval: null,
      isMobilePc: false,
      intervalTime: 60000 * 2, // 60000 * 2 2분
      image: {
        run: require('@/assets/image/monitoring/mak-gr-28.png'), // 가동
        fault: require('@/assets/image/monitoring/mark-rd-28.png'), // 고장
        error: require('@/assets/image/monitoring/mark-yl-28.png') // 통신이상
      },
      inverterTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      siteTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      infoData: {
        siteId: 'M2189',
        title: '홍성 지정리 지정3호태양광',
        location: '충청남도 홍성군 구항면 지정리 129',
        date: day('2020-11-13T15:00:00.000+0000').format('YYYY년 MM월 DD일'),
        charge: '유료',
        cctvView: false
      }
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    // 'parkka0114'는 store.state.user.userId로 변경
    this.from =
      this.$route.query.sido !== undefined &&
      this.$route.query.sigu !== undefined &&
      this.$route.query.sido.length > 0 && this.$route.query.sigu.length > 0
    let userId = store.state.user.userId
    // this.from = true
    getMonitoringPersonal(
      userId,
      this.$route.query.sido,
      this.$route.query.sigu
    ).then(res => {
      this.siteList = res
      this.refreshFlag = !this.refreshFlag
    })
    this.interval = setInterval(() => {
      getMonitoringPersonal(
        userId,
        this.$route.query.sido,
        this.$route.query.sigu
      ).then(res => {
        this.siteList = res
        this.refreshFlag = !this.refreshFlag
      })
    }, this.intervalTime)
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    // setTimeout(() => {
    //   this.showWindow()
    // }, 500)
    // setTimeout(() => {
    //   this.initMap()
    // }, 1000)
    // setTimeout(() => {
    //   this.initMarkers(this.siteList)
    // }, 3000)
    if (isMobile()) {
      this.isMobilePc = true
      // confirmIfExit()
    }
    this.popup2()
    var pwChangeYN = localStore.get('pw_change')
    if (pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
    // this.getMonitorData()
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
  },
  activated() {
    if (this.interval === null) {
      this.interval = setInterval(() => {
        getMonitoringPersonal(
          store.state.user.userId,
          this.$route.query.sido,
          this.$route.query.sigu
        ).then(res => {
          this.siteList = res
          this.refreshFlag = !this.refreshFlag
        })
      }, this.intervalTime)
    }
  },
  deactivated() {
    clearInterval(this.interval)
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    async initMap() {
      const center = new naver.maps.LatLng(35.99678, 127.813624)
      this.map = new naver.maps.Map('maps', {
        center: center,
        zoom: 8,
        minZoom: 2,
        mapTypeId: naver.maps.MapTypeId.HYBRID, // 위성 + 주요도로 타입
        // mapTypeId: naver.maps.MapTypeId.NORMAL,// 일반 타입
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: naver.maps.Position.TOP_CENTER
        },
        zoomControlOptions: {
          position: naver.maps.Position.TOP_RIGHT
        }
      })

      naver.maps.Event.addListener(this.map, 'click', function(e) {
        if (infoWindow instanceof naver.maps.InfoWindow) {
          infoWindow.close()
          infoWindow = {}
        }
      })
    },
    showWindow() {
      this.show = !this.show
    },
    getMonitorData() {
      getMonitoringTotal().then(res => {
        if (res.siteTotal) {
          this.siteTotal = res.siteTotal
        }
        if (res.inverterTotal) {
          this.inverterTotal = res.inverterTotal
        }
        Object.keys(res.sido).forEach(key => {
          this.sidoFlag.push(key)
        })
        this.sidoData = res.sido
        this.flag++
      })
    },
    initMarkers(data) {
      data.forEach((item, i, array) => {
        var marker = new naver.maps.Marker({
          position: new naver.maps.LatLng(item.LOC_LAT, item.LOC_LON),
          lat: item.LOC_LAT,
          lon: item.LOC_LON,
          siteName: item.DESCRIPTION,
          siteId: item.SITE_ID,
          siteAddr: item.LOCATION,
          siteStatus: item.run_status,
          date: item.CRT_DATE,
          type: item.TYPE,
          // seqNo: item.NO,
          map: this.map,
          icon: {
            url: this.image.run,
            size: new naver.maps.Size(33, 33), // 마커 SIZE
            anchor: new naver.maps.Point(11, 35) // anchor 속성은 이미지의 중앙 하단 포인
          },
          seq: i,
          cctvStat: item.CCTV_STAT,
          cctvCnt: item.CCTV_CNT // CCTV추가 2019-10-02
        })
        this.markerList.push(marker)
      })

      for (var j = 0; j < this.markerList.length; j++) {
        naver.maps.Event.addListener(
          this.markerList[j],
          'click',
          function(e, j) {
            var marker = this.markerList[e.overlay.seq]
            this.infoData.date = marker.date
            this.infoData.siteId = marker.siteId
            this.infoData.location = marker.siteAddr
            this.infoData.charge = marker.type
            this.infoData.title = marker.siteName
            this.infoData.cctvView = marker.cctvCnt > 0

            // console.log(this.$refs.infoPop)
            setTimeout(() => {
              infoWindow = new naver.maps.InfoWindow({
                content: $('#infoPop').html(),
                backgroundColor: '#2a3147',
                anchorSize: {
                  width: 0,
                  height: 0
                },
                borderWidth: 0
              })
              infoWindow.open(this.map, marker)
              var siteMap = new naver.maps.LatLng(marker.lat, marker.lon)
              this.map.setCenter(siteMap)
              $('#infoCloseBtn').on('click', function() {
                infoWindow.close()
              })
              $('#infoBtn').on(
                'click',
                function() {
                  if (this.infoData.siteId.indexOf('E') > -1) {
                    this.$router.push(
                      '/ess/siteWork?site_id=' + this.infoData.siteId
                    )
                  } else {
                    this.$router.push(
                      '/siteWork?site_id=' + this.infoData.siteId
                    )
                  }
                }.bind(this)
              )

              $('#cctvBtn').on(
                'click',
                function() {
                  if (isTablet()) {
                    this.$router.push(
                      '/mobile/cctvList?site_id=' + this.infoData.site_id
                    )
                  } else {
                    let routeData = this.$router.resolve({
                      name: 'cctvPopup',
                      query: {
                        cctvInfo: JSON.stringify({
                          cctv_cnt: this.infoData.cctvCnt,
                          site_id: this.infoData.siteId
                        })
                      }
                    })

                    window.open(
                      routeData.href,
                      '',
                      'width=' +
                        window.outerWidth / 1.5 +
                        ', height=' +
                        window.outerHeight / 1.3 +
                        ''
                    )
                  }
                }.bind(this)
              )
            }, 150)
          }.bind(this)
        )
      }
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' }) // 모바일에서 스크롤 이동
    },
    findMarker(siteId) {
      this.markerList.forEach(x => {
        if (x.siteId === siteId) {
          this.infoData.date = x.date
          this.infoData.siteId = x.siteId
          this.infoData.location = x.siteAddr
          this.infoData.charge = x.type
          this.infoData.title = x.siteName

          this.map.setZoom(12, false)
          var siteMap = new naver.maps.LatLng(x.lat, x.lon)

          this.map.setCenter(siteMap)
          // console.log(this.$refs.infoPop)
          setTimeout(() => {
            infoWindow = new naver.maps.InfoWindow({
              content: $('#infoPop').html(),
              backgroundColor: '#2a3147',
              anchorSize: {
                width: 0,
                height: 0
              },
              borderWidth: 0
            })
            infoWindow.open(this.map, x)
            $('#infoCloseBtn').on('click', function() {
              infoWindow.close()
            })
            $('#infoBtn').on(
              'click',
              function() {
                if (this.infoData.siteId.indexOf('E') > -1) {
                  this.$router.push(
                    '/ess/siteWork?site_id=' + this.infoData.siteId
                  )
                } else {
                  this.$router.push('/siteWork?site_id=' + this.infoData.siteId)
                }
              }.bind(this)
            )
          }, 150)
          return true
        }
      })
    },
    popup2() {
      // 첫 화면에서 팝업을 띄운다
      this.layer_type = 'SummaryPopup'

      let found = false
      let start, end
      let i = 0

      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }

      if (found === true) {
        console.log('cookie found')
        this.component_show = false
      } else {
        console.log('cookie not found')
        this.component_show = true
      }

      // this.component_show = true
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.component_show = false
      } else {
        this.component_show = false
      }
      // this.$emit('update:component_show', false)
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
/* 퍼블리셔 작업 영역 */

// lang="less"로 <style> 태그에 속성으로 넣어야 less를 사용할 수 있다.

.test-box {
  border: 1px solid lightgreen;
}

.main-box {
  padding: 0 0 0 0;
}
</style>
